
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","width":"1em","height":"1em","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.167 1.667c.46 0 .833.373.833.833V10h7.5c.46 0 .833.373.833.833A9.177 9.177 0 019.167 20a9.167 9.167 0 110-18.333zM5.833 15.346l-1.341 1.341a7.44 7.44 0 004.312 1.628l-2.97-2.97zm2.5-2.5l-1.32 1.32 3.941 3.944a7.519 7.519 0 001.892-.752l-4.513-4.512zm3.821-1.18H9.512l4.69 4.694c.478-.43.898-.92 1.25-1.458a.837.837 0 01-.208-.146l-3.09-3.09zM8.334 3.38a7.5 7.5 0 00-5.021 12.13l5.02-5.021V3.379zm8.287 8.288h-2.108l1.704 1.704c.2-.55.336-1.122.404-1.704zM12.5 0A7.5 7.5 0 0120 7.5c0 .46-.373.833-.833.833H12.5a.833.833 0 01-.833-.833V.833c0-.46.373-.833.833-.833zm.833 1.727v4.94h4.94a5.833 5.833 0 00-4.94-4.94z"}})])
          )
        }
      }
    